import { render, staticRenderFns } from "./EleveDash.vue?vue&type=template&id=063eee98&"
import script from "./EleveDash.vue?vue&type=script&lang=js&"
export * from "./EleveDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports